"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCalloutText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTextObject = _interopRequireDefault(require("../BaseTextObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledCalloutText = (0, _styledComponents.default)(_BaseTextObject.default).withConfig({
  displayName: "CalloutTextstyles__StyledCalloutText",
  componentId: "t9ktvw-0"
})(["&,& *{font-size:", ";}"], function (props) {
  return props.theme.fontSmall;
});
exports.StyledCalloutText = StyledCalloutText;